import { Form } from 'factorial-form'

interface AutomaticRuleRawValues {
  periodLength?: number | null
  breakDuration?: number | null
  timeSettingsBreakConfigurationId?: number | null
  _destroy?: boolean
}

class AutomaticRuleForm extends Form {
  static defaultValues = {
    periodLength: null,
    breakDuration: null,
    timeSettingsBreakConfigurationId: null,
    _destroy: false,
  }

  constructor(values: AutomaticRuleRawValues = {}) {
    const normalizedValues = {
      periodLength: values.periodLength != null ? values.periodLength / 100 : null,
    }

    super(
      { ...AutomaticRuleForm.defaultValues, ...values, ...normalizedValues },
      {
        id: 'number',
        periodLength: 'string',
        breakDuration: 'string',
        timeSettingsBreakConfigurationId: 'number',
        _destroy: 'boolean',
      }
    )
  }

  data() {
    return {
      ...super.data(),
      periodLength: Math.round(this.get('periodLength').value * 100),
    }
  }

  valid() {
    return this.get('periodLength').value > 0 && this.get('breakDuration').value > 0
  }
}

export default AutomaticRuleForm
